import {UserGroupRoleDto} from "./user-group-role.dto";

export class UserDto {
    id: number;
    emailAddress: string;
    description: string;

    groupRoles: UserGroupRoleDto[];
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/user.dto.ts